<template>
    <div id="f_ocx2">
      <iframe
        name="myiframe"
        id="ocx2"
        :src="cdbm"
        frameborder="0"
        align="middle"
        width="100%"
        height="100%"
        scrolling="no"
        allow="microphone; camera; display-capture;"
      ></iframe>
    </div>
</template>
<script>
export default ({
    name:'SharePlayer',
    props:{
        cdbm:{
          type:String,
          default:''
        }
    },
    data() {
        return {
        }
    },
})
</script>
<style lang="scss" scoped>
  #f_ocx2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
  }
</style>